import React from 'react';
import {connect} from 'react-redux';
import resolvePath from '../../../../misc/resolvePath';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import PleaseWait from '../../PleaseWait';
import Screen from '../../Screen';
import Tabs from '../common/MapTabs';
import ZoomableImage from '../common/ZoomableImage';

class EventMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ready: false,
        };
    }
    componentDidMount() {
        if (!this.props.event.map_url && this.props.event.exhibitors_map_url) {
            app.history.replace(resolvePath(app.history.location.pathname, './exhibitors'));
        } else {
            this.setState({ready: true});
        }
    }
    render() {
        if (!this.state.ready) {
            return <PleaseWait />;
        }

        let {event, i18n} = this.props,
            header = (
                <div>
                    <TopBarEvent event={event} returnURL="..">
                        &nbsp;
                    </TopBarEvent>
                    <hr />
                    <Tabs event={event} i18n={i18n} />
                    <hr />
                </div>
            );

        return (
            <Screen header={header}>
                <ZoomableImage src={this.props.event.map_url} />
            </Screen>
        );
    }
}

const EventMapConnected = connect((state, props) => {
    return {
        event: _(state).get(`events[${props.eventId}].event`),
        i18n: state.i18n.translations,
    };
})(EventMap);

export default props => <EventMapConnected {...props.match.params} />;
